import Libraries from './Libraries'
import Profile from './Profile'

export default [Libraries, Profile]
